import React from 'react';
import classnames from 'classnames';
import border from 'scy/border.mod.scss';
import { plainList } from 'scy/utils.mod.scss';

export default function RadioList({ children, className }) {
  return (
    <ul
      className={classnames(
        plainList,
        border.borderRadius,
        border.allMedium,
        className
      )}
    >
      {children}
    </ul>
  );
}
